import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";

export function usePortal(targetSelector?: string) {
  const [container] = useState(document.createElement("div"));
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const target = targetSelector
      ? document.querySelector(targetSelector)
      : document.body;

    if (target) {
      target.appendChild(container);
      setIsReady(true);
    }

    return () => {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
      setIsReady(false);
    };
  }, [targetSelector, container]);

  const Portal = useMemo(
    () =>
      ({ children }: { children: React.ReactNode }) => {
        if (!isReady) return null;
        return createPortal(children, container);
      },
    [isReady, container],
  );

  return Portal;
}
